import JsonLd from "./JsonLd";
import schemas from "./schemas";

/*
 * SoftwareApplication structured data for the interactive tool pages
 * (/tools/*). All tools are free web apps.
 *
 * Props:
 *   name         (required) — the tool name, e.g. "Race Radar"
 *   description  (recommended) — falls back to the site default if omitted
 *   path         (recommended) — site-relative, e.g. "/tools/race-radar"
 */
export default function ToolSchema(props) {
  return <JsonLd data={schemas.buildToolSchema(props)} />;
}
